// import React, { useEffect } from 'react';
// import TextField from '@mui/material/TextField';
// import { Controller, UseControllerProps } from 'react-hook-form';

// interface ControlledTextAreaProps {
//   label: string;
//   id: string;
//   name: string;
//   className?: string;
//   variant?: "standard" | "filled" | "outlined";
//   disabled?: boolean;
//   control: any;
//   defaultValue?: any;
//   rules?: UseControllerProps['rules'];
//   onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
//   required?: boolean; 
//   setValue?: any;
//   register?: any;
//   maxLength?: number;
//   minLength?: number;
//   rows?: number;
//   hide?:boolean;
//   size?:'small' | 'medium'
// }

// const WSTextAreaField: React.FC<ControlledTextAreaProps> = ({
//   id,
//   label,
//   className,
//   control,
//   name,
//   rules,
//   variant = "outlined",
//   disabled = false,
//   defaultValue = '',
//   setValue,
//   onChange,
//   maxLength,
//   minLength,
//   rows = 4,
//   hide=false,
//   size="medium"
// }) => {
//   useEffect(() => {
//     // Custom logic (if needed)
//   }, []);

//   return (
//     <Controller
//       name={name}
//       control={control}
//       defaultValue={defaultValue}
//       rules={rules}
//       render={({ field, fieldState }) => {
//         return (
//           <TextField
//             id={id}
//             fullWidth
//             size={size}
//             {...field}
//             className={hide===true ? 'ws-hidden' : fieldState.invalid ? 'WSError' : className}
//             label={label}
//             variant={variant}
//             disabled={disabled}
//             error={fieldState.invalid}
//             value={field.value}
//             helperText={fieldState.error ? fieldState.error.message : ''}
//             multiline
//             rows={rows}
//             inputProps={{ maxLength, minLength }}
        
//            sx={{
//   '& .MuiOutlinedInput-root': {
//     borderRadius: '12px',
//     backgroundColor: '#eeeeee',
//     fontSize: '0.8rem',
//     alignItems: 'flex-start', // 👈 important for multiline
//     padding: '6px 0',
//   },
//   '& .MuiOutlinedInput-notchedOutline': {
//     borderColor: '#d6d6d6',
//   },
//   '&:hover .MuiOutlinedInput-notchedOutline': {
//     borderColor: '#c2c2c2',
//   },
//   '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
//     borderColor: '#bdbdbd',
//   },
//   '& .MuiInputBase-input': {
//     padding: '6px 12px',
//     fontSize: '0.8rem',
//   },
//   '& .MuiInputLabel-root': {
//     fontSize: '0.85rem',
//     color: '#000000',
//     transform: 'translate(14px, -29px) scale(1)', // 👈 same top label
//   },
//   '& .MuiOutlinedInput-notchedOutline legend': {
//     width: 0,
//   },
//   '& .MuiFormHelperText-root': {
//     fontSize: '0.75rem',
//   },
// }}
//           />
//         );
//       }}
//     />
//   );
// };

// export default WSTextAreaField;



import React, { useEffect } from 'react';
import TextField from '@mui/material/TextField';
import { Controller, UseControllerProps } from 'react-hook-form';

interface ControlledTextAreaProps {
  label: string;
  id: string;
  name: string;
  className?: string;
  variant?: "standard" | "filled" | "outlined";
  disabled?: boolean;
  control: any;
  defaultValue?: any;
  rules?: UseControllerProps['rules'];
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  required?: boolean; 
  setValue?: any;
  register?: any;
  maxLength?: number;
  minLength?: number;
  rows?: number;
  hide?: boolean;
  size?: 'small' | 'medium';
  // 👈 NEW PROPS FOR QR SCANNING
  inputRef?: React.RefObject<HTMLTextAreaElement>;
  onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
}

const WSTextAreaField: React.FC<ControlledTextAreaProps> = ({
  id,
  label,
  className,
  control,
  name,
  rules,
  variant = "outlined",
  disabled = false,
  defaultValue = '',
  setValue,
  onChange,
  maxLength,
  minLength,
  rows = 4,
  hide = false,
  size = "medium",
  // 👈 NEW PROPS
  inputRef,
  onKeyDown,
}) => {
  useEffect(() => {
    // Custom logic (if needed)
  }, []);

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={defaultValue}
      rules={rules}
      render={({ field, fieldState }) => {
        return (
          <TextField
            id={id}
            fullWidth
            size={size}
            {...field}
            className={hide === true ? 'ws-hidden' : fieldState.invalid ? 'WSError' : className}
            label={label}
            variant={variant}
            disabled={disabled}
            error={fieldState.invalid}
            value={field.value}
            helperText={fieldState.error ? fieldState.error.message : ''}
            multiline
            rows={rows}
            inputProps={{ 
              maxLength, 
              minLength,
              // 👈 FORWARD REFS AND EVENTS
              ref: inputRef,
              onKeyDown: onKeyDown,
            }}
            sx={{
              '& .MuiOutlinedInput-root': {
                borderRadius: '12px',
                backgroundColor: '#eeeeee',
                fontSize: '0.8rem',
                alignItems: 'flex-start', // 👈 important for multiline
                padding: '6px 0',
              },
              '& .MuiOutlinedInput-notchedOutline': {
                borderColor: '#d6d6d6',
              },
              '&:hover .MuiOutlinedInput-notchedOutline': {
                borderColor: '#c2c2c2',
              },
              '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                borderColor: '#bdbdbd',
              },
              '& .MuiInputBase-input': {
                padding: '6px 12px',
                fontSize: '0.8rem',
              },
              '& .MuiInputLabel-root': {
                fontSize: '0.85rem',
                color: '#000000',
                transform: 'translate(14px, -29px) scale(1)', // 👈 same top label
              },
              '& .MuiOutlinedInput-notchedOutline legend': {
                width: 0,
              },
              '& .MuiFormHelperText-root': {
                fontSize: '0.75rem',
              },
            }}
          />
        );
      }}
    />
  );
};

export default WSTextAreaField;